/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user-follow': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M20 8.75h-2.5v-2.5h-1.25v2.5h-2.5V10h2.5v2.5h1.25V10H20V8.75zM7.5 2.5a3.125 3.125 0 110 6.25 3.125 3.125 0 010-6.25zm0-1.25a4.375 4.375 0 100 8.75 4.375 4.375 0 000-8.75zm6.25 17.5H12.5v-3.125c0-1.726-1.4-3.125-3.125-3.125h-3.75A3.125 3.125 0 002.5 15.625v3.125H1.25v-3.125a4.375 4.375 0 014.375-4.375h3.75a4.375 4.375 0 014.375 4.375v3.125z"/>'
  }
})
